import { motion } from "framer-motion";

let lenisRef = null;
export const setLenis = (l) => {
  lenisRef = l;
};
export const scrollToId = (id) => {
  const el = document.querySelector(id);
  if (!el) return;
  if (lenisRef) lenisRef.scrollTo(el, { offset: -72, duration: 1.4 });
  else el.scrollIntoView({ behavior: "smooth" });
};

const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, className = "", y = 48 }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 1, delay, ease: EASE }}
    className={className}
  >
    {children}
  </motion.div>
);

export const Kicker = ({ children }) => (
  <p className="font-display text-xs font-bold uppercase tracking-[0.3em] text-gold">
    {children}
  </p>
);

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
  <span className={`block overflow-hidden ${className}`}>
    <motion.span
      className="block"
      initial={{ y: "110%" }}
      animate={{ y: 0 }}
      transition={{ duration: 1.1, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export { EASE };
